export function messagingtopbarRender() { 
    return `<div id="top-bar" 
                style="${  this.__$objToStyleMap(this.contStyle)  }" 
                class="messaging-top-bar ${  this.config.topBarType === 'material' && this.prop.issurvey == 'false' ? 'messaging-top-bar-material top-bar-material': ''  } ${  this.config.extendedTopBarItems && this.prop.issurvey == 'false' ? 'extended-top-bar': ''  } ">
        
                <div 
                    class="top-bar-main" 
                    style="${  this.__$objToStyleMap(this.barStyle)  }">
                    ${ this.config.centerTopBarItems && this.config.centerTopBarItems.length > 0 ? `<div class="top-bar-center h-100 d-flex">

                ${ this.config.centerTopBarItems.map(function(item) { 
                return `<topbar-element 
                        type="${ item.type }" 
                        imgname="${ item.imgName }" 
                        imgsrc="${ item.imgSrc }" 
                        text="${ item.text || '' }" 
                        subtext="${ item.subText }" 
                        mode="${ item.mode }" 
                        hiddenstates="${ item.hiddenStates && item.hiddenStates.join(',') || '' }" 
                        hiddendevices="${ item.hiddenDeviceTypes && item.hiddenDeviceTypes.join(',') || '' }" 
                        audioonimgname="${ item.audioOnImgName }" 
                        audiooffimgname="${ item.audioOffImgName }">
                        </topbar-element>` }.bind(this)).join('') }

                        </div>`:`` }

                        ${ this.config.leftTopBarItems ? `<div class="top-bar-left h-100 d-flex">

                        ${ this.config.leftTopBarItems.map(function(item) { 
                            return `<div>
                                    ${ item.type == 'Overflow' ?
                                    `<overflow-menu 
                                        class="overflow-menu top-bar-item left" 
                                        style="${  this.__$objToStyleMap(this.topBarIconStyle)  }" 
                                        hiddenstates="${ item.hiddenStates && item.hiddenStates.join(',') || '' }" 
                                        overflowmenuitems="${ encodeURIComponent(JSON.stringify(this.config.leftOverFlowItems)) }" 
                                        overflowmenustyle="${ encodeURIComponent(JSON.stringify(this.leftOverFlowMenuStyle)) }">
                                    </overflow-menu>`
                                    :
                                    `<topbar-element 
                                        type="${ item.type }" 
                                        imgname="${ item.imgName }"
                                        imgsrc="${ item.imgSrc }" 
                                        text="${ item.text || '' }" 
                                        subtext="${ item.subText }" 
                                        mode="${ item.mode }" 
                                        hiddenstates="${ item.hiddenStates && item.hiddenStates.join(',') || '' }" 
                                        hiddendevices="${ item.hiddenDeviceTypes && item.hiddenDeviceTypes.join(',') || '' }" 
                                        audioonimgname="${ item.audioOnImgName }" audiooffimgname="${ item.audioOffImgName }">
                                        </topbar-element>` }
                                        </div>` }.bind(this)).join('') }
                                        </div>`:`` 
                                    }

    ${ this.config.rightTopBarItems ? 
        `<div class="top-bar-right h-100 d-flex">
        ${ this.config.rightTopBarItems.map(function(item) { 
                    return `<div>
                            ${ item.type == 'Overflow'  && !item.hiddenStates?.includes(this.prop.surtype) ? 
                            `<overflow-menu 
                                    class="overflow-menu top-bar-item right" 
                                    style="${  this.__$objToStyleMap(this.topBarIconStyle)  }" 
                                    hiddenstates="${ item.hiddenStates && item.hiddenStates.join(',') || '' }" 
                                    overflowtitle="${ item.text || 'Menu' }" 
                                    overflowmenuitems="${ encodeURIComponent(JSON.stringify(this.config.rightOverFlowItems)) }" 
                                    overflowmenustyle="${ encodeURIComponent(JSON.stringify(this.rightOverFlowMenuStyle)) }">
                            </overflow-menu>`
                            :`<topbar-element 
                                    type="${ item.type }" 
                                    imgname="${ item.imgName }" 
                                    imgsrc="${ item.imgSrc }" 
                                    text="${ item.text || '' }" 
                                    subtext="${ item.subText }" 
                                    mode="${ item.mode }" 
                                    hiddenstates="${ item.hiddenStates && item.hiddenStates.join(',') || '' }" 
                                    hiddendevices="${ item.hiddenDeviceTypes && item.hiddenDeviceTypes.join(',') || '' }" 
                                    audioonimgname="${ item.audioOnImgName }" 
                                    audiooffimgname="${ item.audioOffImgName }">
                                    </topbar-element>` }
                                    </div>` }.bind(this)).join('') }
                                </div>`:`` }
    <div style="clear:both;"></div>

    ${ this.config.topBarType == 'material' && this.config.materialBarItems && this.prop.issurvey == 'false' ? `<div class="top-bar-material-container">
       ${ this.config.materialItemPosition == 'left' ? `<div class="top-material h-100 d-flex">
           <div>
               ${ this.config.materialBarItems.map(function(item) { 
                return `<topbar-element type="${ item.type }" 
                                        imgname="${ item.imgName }" 
                                        imgsrc="${ item.imgSrc }" 
                                        text="${ item.text || '' }" 
                                        audioonimgname="${ item.audioOnImgName }" 
                                        audiooffimgname="${ item.audioOffImgName }">
                                        </topbar-element>` }.bind(this)).join('') }
           </div>
       </div>`:`` }
        ${ this.config.materialItemPosition == 'center' ? `<div class="top-material-center h-100 d-flex">
            <div class="w-100">
                ${ this.config.materialBarItems.map(function(item) {
                     return `<div class="d-flex">
                    <topbar-element type="${ item.type }" 
                                    imgname="${ item.imgName }" 
                                    imgsrc="${ item.imgSrc }" 
                                    text="${ item.text }" 
                                    audioonimgname="${ item.audioOnImgName }" 
                                    audiooffimgname="${ item.audioOffImgName }">
                                    </topbar-element>
                </div>` }.bind(this)).join('') }
            </div>
        </div>`:`` }
        ${ this.config.materialItemPosition == 'adjacent' ? `<div class="top-material-adjacent h-100 d-flex">
            ${ this.config.materialBarItems.map(function(item) { 
                return `<topbar-element type="${ item.type }" 
                                        imgname="${ item.imgName }" 
                                        imgsrc="${ item.imgSrc }" 
                                        text="${ item.text || '' }" 
                                        audioonimgname="${ item.audioOnImgName }" 
                                        audiooffimgname="${ item.audioOffImgName }">
                                        </topbar-element>` }.bind(this)).join('') }
            </div>`:`` }
        </div>`:`` }
        </div>
    ${ this.config.extendedTopBarItems && (this.prop.issurvey == 'false' || this.config.extendedTopBarInSurvey) ? `<div class="messaging-top-bar-extended" style="${  this.__$objToStyleMap(this.extendStyle)  }">
        ${ this.config.extendedTopBarItems.map(function(item) { 
            return `<topbar-element type="${ item.type }" 
                                    imgname="${ item.imgName || '' }" 
                                    imgsrc="${ item.imgSrc || '' }" 
                                    text="${ item.text || '' }" 
                                    subtext="${ item.subText }" 
                                    mode="${ item.mode }" 
                                    hiddenstates="${ item.hiddenStates && item.hiddenStates.join(',') || '' }"
                                    hiddendevices="${ item.hiddenDeviceTypes && item.hiddenDeviceTypes.join(',') || '' }" 
                                    audioonimgname="${ item.audioOnImgName }" 
                                    audiooffimgname="${ item.audioOffImgName }" 
                                    extended="true" 
                                    style="${  this.__$objToStyleMap(this.extendItemStyle)  }" ld--elist="click" ld-on-click="onIconClick">
                                    </topbar-element>` }.bind(this)).join('') }
    </div>`:`` }
</div>
`  }